import React from 'react'
import KeyTakeawaysCard from './KeyTakeawaysCard'
import { KeyTakeawaysCardProps, KeyTakeawaysProps } from './KeyTakeaways.d'

const KeyTakeaways = ({
  heading,
  keyTakeaways,
  uniqueId
}: KeyTakeawaysProps) => {
  return (
    <section className='font-sansPro' data-testid='KeyTakeaways' id={uniqueId}>
      <h2 className='text-otl-cta-heading font-semibold font-calibre'>
        {heading}
      </h2>
      <div className='grid grid-cols-1 md:grid-cols-2 gap-4 mt-6'>
        {keyTakeaways.map((takeaway: KeyTakeawaysCardProps) => (
          <KeyTakeawaysCard key={takeaway.title} {...takeaway} />
        ))}
      </div>
    </section>
  )
}

export default KeyTakeaways
